// libraries
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

// styles
import styles from "./styles.module.scss";

// assets
import share from "../../../assets/images/details/share.svg";
import facebook from "../../../assets/images/details/facebook.svg";
import linkedin from "../../../assets/images/details/linkedin.svg";
import twitter from "../../../assets/images/details/twitter.svg";
import email from "../../../assets/images/details/email.svg";
import whatsapp from "../../../assets/images/details/whatsapp.svg";
import phone from "../../../assets/images/details/phone.svg";

// utils
import { convertToSlug } from "src/utils/helpers";

const Keywords = ({ data }) => {
  const [url, setUrl] = useState("");
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (data) {
      let origin = window.location.origin;
      let slug = convertToSlug(data?.EventName);

      let link = `${origin}/${slug}/${data?.EventId}/${data?.TimeId}`;
      setUrl(link);

      setTags(getTags(data.Tags));
    }
  }, [data]);

  const trimText = (_str, _length) => {
    if (!_str) return "";
    return _str.substring(0, _length);
  };

  const getTags = (_str) => {
    if (_str && _str !== "") {
      let arr = _str.split(",");
      return arr;
    }

    return [];
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(url);

    toast.success("url copied", {
      className: "bg-blue",
      position: "bottom-center",
    });
  };

  return (
    <div className={styles.keywords}>
      <div className={styles.wrap}>
        <h6>Keywords</h6>
        {tags.length > 0 && (
          <div className={styles.tags}>
            {tags.map((item, index) => (
              <span key={index}>{item}</span>
            ))}
          </div>
        )}
        <div className={styles.copy_link}>
          <span>eventmoon/{trimText(convertToSlug(data?.EventName), 10)}</span>
          <span onClick={handleCopy} className={styles.copy_btn}>
            Copy Link
          </span>
        </div>
        <div className={styles.share}>
          <h5>
            <img src={share} alt="share" />
            Share with Friends
          </h5>
          <span className={styles.icon_wrapper}>
            <img src={facebook} alt="facebook" className={styles.facebook} />
            <img src={linkedin} alt="linkedin" className={styles.linkedin} />
            <img src={twitter} alt="twitter" className={styles.twitter} />
            <img src={email} alt="email" className={styles.email} />
            <img src={whatsapp} alt="whatsapp" className={styles.whatsapp} />
            <img src={phone} alt="phone" className={styles.phone} />
          </span>
          <span onClick={handleCopy} className={styles.copy_btn}>
            Copy Link
          </span>
        </div>
      </div>
    </div>
  );
};

export default Keywords;
